var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show_mb"},[_c('img',{staticClass:"shengyiback",attrs:{"src":"https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/web/build/dist/img/shengyibefor.png"}}),_c('div',{staticClass:"shengyifoot"},[_c('button',{staticClass:"shengyibutton",on:{"click":_vm.goquestion}},[_c('a',{attrs:{"href":_vm.url}},[_vm._v("开始答题")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }